/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoleFromJSON, RoleToJSON, } from './Role.js';
/**
 * Check if a given object implements the UserDto interface.
 */
export function instanceOfUserDto(value) {
    if (!('role' in value) || value['role'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('externalId' in value) || value['externalId'] === undefined)
        return false;
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
export function UserDtoFromJSON(json) {
    return UserDtoFromJSONTyped(json, false);
}
export function UserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'role': RoleFromJSON(json['role']),
        'id': json['id'],
        'externalId': json['externalId'],
        'displayName': json['displayName'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
    };
}
export function UserDtoToJSON(json) {
    return UserDtoToJSONTyped(json, false);
}
export function UserDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'role': RoleToJSON(value['role']),
        'id': value['id'],
        'externalId': value['externalId'],
        'displayName': value['displayName'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
    };
}
